import * as React from 'react';

import classnames from 'classnames';

import styles from './main-content-container.module.css';

/*
This component provides a consistent outer container for components rendered
to the right of a navigation sidebar, inside a `page-main-content` div
(e.g. in the settings page)
 */
export class MainContentContainer extends React.PureComponent<{
    children?: any;
    includesHeader: boolean;
    whiteBackground?: boolean;
    minWidth?: number;
    // Mostly used on settings pages where the outer sidebar needs
    // to dictate the scroll container height.
    preventInnerScroll?: boolean;
    darkBackground?: boolean;
}> {
    static defaultProps = {
        includesHeader: true,
    };

    render() {
        const innerContainerStyleName = classnames({
            [styles['container-inner']]: true,
            [styles['container-inner--white']]: this.props.whiteBackground,
            [styles['container-inner--no-scroll']]: this.props.preventInnerScroll,
            [styles['container-inner--dark']]: this.props.darkBackground,
        });

        return (
            <div
                className={
                    this.props.includesHeader ? styles.container : styles['container--no-header']
                }
            >
                <div
                    style={this.props.minWidth ? {minWidth: this.props.minWidth} : undefined}
                    className={innerContainerStyleName}
                >
                    {this.props.children}
                </div>
            </div>
        );
    }
}
